import { NavigationMenuItem } from '@models/navigation-menu-item';
import { RoleType } from '@shared/enums/role-type';
import { hlContactUsMenu } from './contact-us-menu';
import { zbHelpMenu } from './help-menu';

export const SCHOOL_ADMIN_MANAGE_MENU_ID = 'SchoolManage';

export const schoolHLAdminMainMenus: NavigationMenuItem[] = [
  hlContactUsMenu,
  { id: SCHOOL_ADMIN_MANAGE_MENU_ID, isRouted: false, isExternal: false, label: 'Manage', weight: -10 },
];

export const schoolZBAdminMainMenus: NavigationMenuItem[] = [
  zbHelpMenu,
  { id: SCHOOL_ADMIN_MANAGE_MENU_ID, isRouted: false, isExternal: false, label: 'Manage', weight: -10 },
];

/**
 * Default Submenu links for School Administrators.
 *
 * The label should have the first letter of the first word capitalized.
 */
export const schoolAdminManageDropdownMenus: NavigationMenuItem[] = [
  {
    id: 'manage-users',
    isRouted: true,
    route: 'users',
    isExternal: false,
    label: 'Manage users',
    weight: 1,
    roleType: RoleType.SchoolAdministrator,
  },
  {
    id: 'assign-revoke-licenses',
    isRouted: true,
    isExternal: false,
    route: 'licenses',
    label: 'Assign and revoke licenses',
    weight: 2,
    roleType: RoleType.SchoolAdministrator,
  },
  {
    id: 'class-user-statistics',
    isRouted: true,
    isExternal: false,
    route: '/overview',
    label: 'Class and user statistics',
    weight: 3,
    roleType: RoleType.SchoolAdministrator,
  },
];

/**
 * Submenu links for School Administrators in Highlights Portal.
 *
 * The label should have the first letter of the first word capitalized.
 */
export const schoolAdminManageDropdownMenusHighlightsPortal = schoolAdminManageDropdownMenus.filter(menu => (
  !['class-user-statistics', 'manage-classes'].includes(menu.id)
));

/**
 * Default Submenu links for School Administrators.
 *
 * The label should have the first letter of the first word capitalized.
 */
export function buildSchoolAdminZBRedesignMenus(
  needsSchoolId: boolean, schoolId: string = null, licenseExpired: boolean = false): NavigationMenuItem[] {
  return [
    {
      id: 'overview',
      isRouted: true,
      route: 'overview',
      isExternal: false,
      label: 'Overview',
      weight: 1,
      roleType: RoleType.SchoolAdministrator,
      schoolId,
    },
    {
      id: 'manage-users',
      isRouted: true,
      route: 'users',
      isExternal: false,
      label: 'Manage users',
      weight: 2,
      roleType: RoleType.SchoolAdministrator,
      disabled: needsSchoolId,
      tooltip: needsSchoolId ? 'These links are disabled until a school ID has been set' : '',
      schoolId,
    },
    {
      id: 'classrooms',
      isRouted: true,
      isExternal: false,
      route: 'classrooms',
      label: 'Manage classes',
      weight: 3,
      roleType: RoleType.SchoolAdministrator,
      disabled: needsSchoolId,
      tooltip: needsSchoolId ? 'These links are disabled until a school ID has been set' : '',
      schoolId,
    },
    {
      id: 'assign-revoke-licenses',
      isRouted: true,
      isExternal: false,
      route: 'licenses',
      label: 'Assign and revoke licenses',
      weight: 4,
      roleType: RoleType.SchoolAdministrator,
      disabled: needsSchoolId || licenseExpired,
      tooltip: needsSchoolId ? 'These links are disabled until a school ID has been set' : '',
      schoolId,
    },
  ];
}

export function buildSchoolAdminHLRedesignMenus(needsSchoolId: boolean, schoolId: string = null): NavigationMenuItem[] {
  return [
    {
      id: 'manage-users',
      isRouted: true,
      route: 'users',
      isExternal: false,
      label: 'Manage users',
      weight: 2,
      roleType: RoleType.SchoolAdministrator,
      disabled: needsSchoolId,
      tooltip: needsSchoolId ? 'These links are disabled until a school ID has been set' : '',
      schoolId,
    },
    {
      id: 'assign-revoke-licenses',
      isRouted: true,
      isExternal: false,
      route: 'licenses',
      label: 'Assign and revoke licenses',
      weight: 4,
      roleType: RoleType.SchoolAdministrator,
      disabled: needsSchoolId,
      tooltip: needsSchoolId ? 'These links are disabled until a school ID has been set' : '',
      schoolId,
    },
  ];
}
